import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { GridDataResult, KENDO_GRID, PageChangeEvent, PagerSettings } from '@progress/kendo-angular-grid';
import { CompositeFilterDescriptor, State } from '@progress/kendo-data-query';
import { Observable } from 'rxjs';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SystemLanguageCodesService } from './system-language-codes.service';
import { SystemLanguageCodeModel } from './models/system-language-code-model';
import { EditSystemLanguageCodeComponent } from './child-components/edit-system-language-code.component';
import { ConfirmDeleteComponent } from '../items/child-components/confirm-delete.component';

@Component({
    selector: 'app-system-language-codes',
    standalone: true,
    imports: [CommonModule, FormsModule, KENDO_GRID, NgbModule],
    providers: [SystemLanguageCodesService],
    templateUrl: './system-language-codes.component.html'
})
export class SystemLanguageCodesComponent implements OnInit {
    public view: Observable<GridDataResult>;
    public error: boolean = false;
    public errorMessage: string = '';

    public state: State = {
        skip: 0,
        take: 20,
    };

    public pageableSettings: PagerSettings = {
        pageSizes: [10, 20, 50, 100]
    };

    public filter: CompositeFilterDescriptor = {
        logic: 'and',
        filters: [],
    };

    constructor(public systemLanguageCodesService: SystemLanguageCodesService, private modalService: NgbModal) {
        this.view = systemLanguageCodesService;
        this.systemLanguageCodesService.query(this.state, this.filter);
    }

    ngOnInit(): void {}

    public pageChange(state: PageChangeEvent): void {
        this.state.skip = state.skip;
        this.state.take = state.take;
        this.systemLanguageCodesService.query(this.state, this.filter);
    }

    public filterChange(filter: CompositeFilterDescriptor): void {
        this.filter = filter;
        this.state.skip = 0;
        this.systemLanguageCodesService.query(this.state, this.filter);
    }

    public addLanguageCode(): void {
        const modalRef = this.modalService.open(EditSystemLanguageCodeComponent, { size: 'lg' });
        modalRef.componentInstance.isNew = true;

        modalRef.result.then((result) => {
            if (result?.action === 'save') {
                this.systemLanguageCodesService.query(this.state, this.filter);
            }
        }, () => {});
    }

    public editLanguageCode(row: SystemLanguageCodeModel): void {
        const modalRef = this.modalService.open(EditSystemLanguageCodeComponent, { size: 'lg' });
        modalRef.componentInstance.isNew = false;
        modalRef.componentInstance.languageCode = row;

        modalRef.result.then((result) => {
            if (result?.action === 'save') {
                this.systemLanguageCodesService.query(this.state, this.filter);
            }
        }, () => {});
    }

    public deleteLanguageCode(row: SystemLanguageCodeModel): void {
        const modalRef = this.modalService.open(ConfirmDeleteComponent);
        modalRef.componentInstance.title = 'Confirm Delete';
        modalRef.componentInstance.message = `Are you sure you want to delete language code "${row.languageName}" (${row.languageCode_ISO639_1})?`;

        modalRef.result.then((result) => {
            if (result === 'confirmed') {
                this.systemLanguageCodesService.delete(row.id).subscribe({
                    next: () => {
                        this.systemLanguageCodesService.query(this.state, this.filter);
                    },
                    error: (error) => {
                        console.error('Error deleting language code:', error);
                        this.error = true;
                        this.errorMessage = error?.error?.message || error?.message || 'Failed to delete the language code. Please try again.';
                    }
                });
            }
        }, () => {});
    }
}
